import React from 'react';

const PageSuccess = () => (
    <div>
        <h1>Thanks for the submission!</h1>
    </div>
);

export default PageSuccess;